export const getScoreColor = (score: number): string => {
  if (score >= 80) return '#22c55e';
  if (score >= 60) return '#eab308';
  return '#ef4444';
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};

export const getMonthName = (date: Date): string =>
  date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

export function formatDateForApi(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function getMonthDateRange(month: Date): { startDate: string; endDate: string } {
  const start = new Date(month.getFullYear(), month.getMonth(), 1, 0, 0, 0);
  const end = new Date(month.getFullYear(), month.getMonth() + 1, 0, 23, 59, 59);
  return { startDate: formatDateForApi(start), endDate: formatDateForApi(end) };
}

export const getScoreLabel = (score: number): { text: string; color: string; bg: string } => {
  if (score >= 80) return { text: 'Strong', color: '#22c55e', bg: '#f0fdf4' };
  if (score >= 60) return { text: 'Needs Work', color: '#eab308', bg: '#fefce8' };
  return { text: 'Poor', color: '#ef4444', bg: '#fef2f2' };
};

export const generateTakeaway = (call: { tourInvited: boolean; scores: { title: string; highlighted: boolean; score: number; max: number }[] }): string => {
  const parts: string[] = [];
  if (call.tourInvited) {
    parts.push('Tour secured');
  } else {
    parts.push('Tour not invited');
  }

  const regular = call.scores.filter(s => !s.highlighted && s.max > 0);
  const weakest = regular.length > 0
    ? regular.reduce((w, s) => (s.score / s.max < w.score / w.max ? s : w))
    : null;
  if (weakest && weakest.score / weakest.max < 0.5) {
    parts.push(`needs work on ${weakest.title.toLowerCase()}`);
  }

  return parts.join(' — ');
};
